import { Dialog } from '@mui/material';
import { type ConnectedProps, connect } from 'react-redux';
import { type RootState } from '@/state';
import { isModalOpen, modalType, modalData, closeModal } from '../state';
import { getModalContent } from './getModalContent';
import styles from './styles';

type Props = ConnectedProps<typeof connector>;

const Modal = ({ isModalOpen, modalType, modalData, closeModal }: Props) => {
  const ModalContent = getModalContent(modalType);

  const handleClose = () => {
    closeModal();
  };

  const paperSx = modalData?.modalStyles ?? styles.paper;
  const dialogSx = modalData?.dialogSx ?? {};

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleClose}
      closeAfterTransition={false}
      sx={dialogSx}
      slotProps={{
        paper: {
          sx: paperSx,
        },
      }}
    >
      <ModalContent closeModal={handleClose} modalData={modalData} />
    </Dialog>
  );
};

const connector = connect(
  (state: RootState) => ({
    isModalOpen: isModalOpen(state),
    modalType: modalType(state),
    modalData: modalData(state),
  }),
  { closeModal },
);

export default connector(Modal);
